export enum ActionType {
    COMMITMENT_NARRATIVE__RELOAD = 'COMMITMENT_NARRATIVE__RELOAD',
    COMMITMENT_NARRATIVE__RELOAD_RESULT = 'COMMITMENT_NARRATIVE__RELOAD_RESULT',
    COMMITMENT_NARRATIVE__APPLY_FILTERS = 'COMMITMENT_NARRATIVE__APPLY_FILTERS',
    COMMITMENT_NARRATIVE__ADD_NOTE = 'COMMITMENT_NARRATIVE__ADD_NOTE',
    COMMITMENT_NARRATIVE__TOGGLE_EXPAND_NOTE = 'COMMITMENT_NARRATIVE__TOGGLE_EXPAND_NOTE',
    COMMITMENT_NARRATIVE__UPDATE_OR_REMOVE_NOTE = 'COMMITMENT_NARRATIVE__UPDATE_OR_REMOVE_NOTE',
}
